module.exports = __webpack_public_path__ + "img/undraw-target.69bfc05b.svg";